"use client";

import React from "react";

import { SVGIcon } from "./SVGIcon";

const getPath = (selected: boolean, selectedColor?: string) => (
  <>
    <path
      d="M1.17993 6.32861L5.09807 7.7069C5.72084 7.92597 6.19538 8.43825 6.36625 9.07593L12.1244 30.5655M17.2876 34.1007L29.0882 30.9387"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <rect
      x="13.6499"
      y="20.7322"
      width="16.8491"
      height="8.70451"
      rx="1.375"
      transform="rotate(-15 13.6499 20.7322)"
      fill={selected ? selectedColor || "#D1E0E6" : undefined}
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <rect
      x="10.4875"
      y="8.93169"
      width="9.60947"
      height="8.70451"
      rx="1.375"
      transform="rotate(-15 10.4875 8.93169)"
      fill={selected ? selectedColor || "#D1E0E6" : undefined}
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <circle
      cx="12.8586"
      cy="35.0533"
      r="4.12602"
      transform="rotate(-15 12.8586 35.0533)"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <circle
      cx="12.859"
      cy="35.0533"
      r="1.53615"
      transform="rotate(-15 12.859 35.0533)"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </>
);

const createPackagesIcon = (selected: boolean) => {
  const displayName = `Packages${selected ? "Selected" : ""}`;
  const Component = React.memo(
    ({ selectedColor, ...props }: SVGIcon.IProps & { selectedColor?: string } & React.RefAttributes<SVGElement>) => (
      <SVGIcon viewBox="0 0 33 41" fill="none" {...props}>
        {getPath(selected, selectedColor)}
      </SVGIcon>
    )
  );
  if (process.env.NODE_ENV !== "production") {
    Component.displayName = `${displayName}Icon`;
  }
  return Component;
};

/**
 * Dynamic version of the icon's variants.
 * @trackcomponent
 */
export const PackagesVariableIcon = React.memo(
  ({ selected, selectedColor, ...props }: SVGIcon.IProps & { selected: boolean; selectedColor?: string } & React.RefAttributes<SVGElement>) => (
    <SVGIcon viewBox="0 0 33 41" fill="none" {...props}>
      {getPath(selected, selectedColor)}
    </SVGIcon>
  )
);
if (process.env.NODE_ENV !== "production") {
  PackagesVariableIcon.displayName = `PackagesIcon`;
}

/**
 * @trackcomponent
 */
export const Packages = createPackagesIcon(false);

/**
 * @trackcomponent
 */
export const PackagesSelected = createPackagesIcon(true);
